import {
  DASHBOARD_CONFIG_FETCH_START,
  DASHBOARD_CONFIG_FETCH_SUCCESS,
  DASHBOARD_CONFIG_FETCH_ERROR,
  DASHBOARD_CONFIG_SAVE_SUCCESS,
  DASHBOARD_CONFIG_SAVE_ERROR,
  UNSAVED_DASHBOARD_CONFIG_STATE_CHANGE,
  PRIORITY_DASHBOARD_CONFIG_FETCH_SUCCESS,
  PRIORITY_DASHBOARD_CONFIG_FETCH_ERROR,
  PRIORITY_DASHBOARD_CONFIG_FETCH_START,
  WIDGET_SCROLL_COMPLETED,
  UPDATE_METRIC_SELECTED_STAT,
} from "../thunks/DashboardConfigurationDispatcher";

const initial = { loading: null };

/**
 * Reducer for dashboard config
 */
export function dashboardConfigReducer(state = initial, action) {
  switch (action.type) {
    case DASHBOARD_CONFIG_FETCH_START: {
      return { ...state, loading: true, error: null };
    }
    case DASHBOARD_CONFIG_FETCH_SUCCESS: {
      return { ...action.payload, loading: false, error: null };
    }
    case DASHBOARD_CONFIG_FETCH_ERROR: {
      return { ...state, loading: false, error: action.error };
    }
    case DASHBOARD_CONFIG_SAVE_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        error: null,
      };
    }
    case DASHBOARD_CONFIG_SAVE_ERROR: {
      return { ...state, error: action.error, loading: false };
    }

    default:
      return state;
  }
}

/**
 * Reducer for unsaved dashboard config
 */
export function unsavedDashboardConfigReducer(state = initial, action) {
  switch (action.type) {
    case DASHBOARD_CONFIG_FETCH_SUCCESS: {
      return { ...action.payload, loading: false, error: null };
    }
    case UNSAVED_DASHBOARD_CONFIG_STATE_CHANGE: {
      return { ...action.payload };
    }
    case WIDGET_SCROLL_COMPLETED: {
      return { ...state, lastAddedWidgetId: null };
    }
    case UPDATE_METRIC_SELECTED_STAT: {
      return { ...action.payload };
    }
    default:
      return state;
  }
}

/**
 * Reducer for priority dashboard config
 */
export function priorityDashboardConfigReducer(state = initial, action) {
  switch (action.type) {
    case PRIORITY_DASHBOARD_CONFIG_FETCH_START: {
      return { ...state, loading: true, error: null };
    }
    case PRIORITY_DASHBOARD_CONFIG_FETCH_SUCCESS: {
      return { ...action.payload, loading: false, error: null };
    }
    case PRIORITY_DASHBOARD_CONFIG_FETCH_ERROR: {
      return { ...state, loading: false, error: action.error };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/DashboardConfigReducer.js